
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
import axios from 'axios';
import api from '@/api/';
import store from '@/store/store';
import {setToken, getToken, setTokenTime, getTokenTime} from './cookie';
import config from '@/config';
import {getEnvFromOrigin, getServiceUrl} from '@/config/imServiceUrl';
import Cookies from "js-cookie";
import {
  verifyLoginTicket, getOngoingActivities, getMallAdvertising, webDataCollectionFn, getQueryString,
  commonSessionStorage, isAlibabaDistributor, getCommonParamKeysData, commonLocalStorage, changeUserLanguages,
  getSystemType, isInterceptorHandled,
} from "@/utils/common";
import Vue from "vue";
import {Modal} from "view-design";
// 获取token
const versionName = 'YMS_version';

let pathname = window.location.pathname;
let system = '';
let targetService = '';
let pathnameList = [
  {system: 'yms', pathname: '/yms.html', service: 'yms-core-service'},
  {system: 'supplier', pathname: '/supplier.html', service: 'yms-supplier-service'},
  {system: 'distributor', pathname: '/distributor.html', service: 'yms-distributor-service'}
];
pathnameList.map((item) => {
  if (pathname.includes(item.pathname)) {
    targetService = item.service;
    system = item.system;
  }
});

let listingTimer = null;
let refreshTokenTimer = null;
let versionChecked = false;
let imInitKey = '';

/**
 * 创建单例 token 刷新定时器。
 * @param {number} delay 下次触发刷新的延迟时间。
 * @param {boolean} setShopToken 是否需要同步刷新商城 cookie token。
 */
const setRefreshTokenTimer = (delay, setShopToken) => {
  clearTimeout(refreshTokenTimer);
  refreshTokenTimer = setTimeout(() => {
    refreshToken(config.curTime, setShopToken);
  }, delay);
};

/**
 * 仅在当前页面生命周期内执行一次版本校验。
 */

/**
 * 按当前用户信息幂等初始化 IM。
 * @param {Object} params IM 初始化参数。
 * @param {string} params.merchantId 商户编号。
 * @param {string} params.memberId 用户编号。
 * @param {string} params.memberName 用户名称。
 * @param {string} params.role 用户角色。
 * @param {string} params.loginUrl IM 登录跳转地址。
 */
const ensureImInit = ({merchantId = '', memberId = '', memberName = '', role = '', loginUrl = ''} = {}) => {
  const nextKey = `${merchantId || 'anonymous'}:${memberId || 'anonymous'}:${loginUrl || ''}`;
  if (nextKey === imInitKey) return;
  imInit({merchantId, memberId, memberName, role, loginUrl});
  imInitKey = nextKey;
};
export const getTokenByListing = () => {
  let ticket = getQueryString('ticket');
  return new Promise(resolve => {
    axios.get(api.get_token + ticket, {
      headers: {'Authorization-Special': 'no-Login'}
    }).then(response => {
      if (response.data.code === 0) {
        setToken(response.data.datas.token);
        resolve();
        clearTimeout(listingTimer);
        refreshTokenByListing();
      } else {
        resolve();
      }
    }).catch(() => {
      resolve();
    });
  });
};
export const refreshTokenByListing = () => {
  axios.get(api.get_refresh_token + getToken()).then(response => {
    if (response.data.code === 0) {
      setToken(response.data.datas.token);
      listingTimer = setTimeout(function () {
        refreshTokenByListing();
      }, config.curTime);
    }
  });
};
/**
 * 通过 ticket 换取访问 token。
 * @param {string} path 当前访问路径。
 * @param {boolean} value 是否同步写入商城 cookie token。
 * @returns {Promise<boolean>} 获取成功返回 true，失败返回 false。
 */
export const getAccessToken = (path, value) => {
  return new Promise(resolve => {
    if (path.indexOf('ticket') > 0) {
      let ticket = getQueryString('ticket');
      axios.get(api.get_token + ticket).then(response => {
        if (response.data.code === 0) {
          setTokenTime(config.token_time);
          setToken(response.data.datas.token);
          localStorage.setItem('systemAnnouncementNotice', JSON.stringify(true));
          // 只有在商城和店铺的时候才需要缓存shop_token 的cookie值
          if (value) {
            let inFifteenMinutes = new Date(new Date().getTime() + (config.token_time + config.curTime));
            Cookies.set('shop_token', response.data.datas.token, {
              expires: inFifteenMinutes,
              path: '/',
              domain: '.yms.com'
            });
          }
          resolve(true);
          return;
        }
        resolve(false);
      }).catch((e) => {
        console.error('getAccessToken error:', e);
        resolve(false);
      });
    } else {
      resolve(true);
    }
  });
};

/**
 * 刷新当前登录 token，并确保全局只有一条刷新调度链。
 * @param {number} curTime 刷新间隔。
 * @param {boolean} setShopToken 是否同步更新商城 cookie token。
 * @returns {Promise<boolean>} 刷新链启动成功返回 true，否则返回 false。
 */
export const refreshToken = (curTime, setShopToken) => {
  const timeout = Number(getTokenTime()) || 0;
  const token = getToken();
  if (!token) {
    clearTimeout(refreshTokenTimer);
    return Promise.resolve(false);
  }
  if (timeout <= config.curTime) {
    return axios.get(api.get_refresh_token + token).then(response => {
      if (response.data.code === 0) {
        setTokenTime(config.token_time);
        setToken(response.data.datas.token);
        if (setShopToken) {
          let inFifteenMinutes = new Date(new Date().getTime() + (config.token_time + config.curTime));
          let domain = window.location.host.replace(/.*?(?=\.)/, '');
          Cookies.set('shop_token', response.data.datas.token, {
            expires: inFifteenMinutes,
            path: '/',
            domain: domain
          });
        }
        setRefreshTokenTimer(config.curTime, setShopToken);
        return true;
      }
      clearTimeout(refreshTokenTimer);
      return false;
    }).catch((e) => {
      console.error('refreshToken error:', e);
      clearTimeout(refreshTokenTimer);
      return false;
    });
  }
  setTokenTime(timeout - curTime);
  setRefreshTokenTimer(config.curTime, setShopToken);
  return Promise.resolve(true);
};
/**
 * 获取 ERP 配置，并在成功后同步基础运行时状态。
 * @param {string} type 当前系统类型。
 * @param {boolean} forceFlush 是否强制忽略缓存重新请求。
 * @returns {Promise<Object|boolean>} 成功返回配置对象，失败返回 false。
 */
export const getErpconfig = (type, forceFlush) => {
  
  const configureBasicInformation = async (data) => {
    let {merchant, userInfo} = data || {};
    if (!merchant || !userInfo) return false;
    let isAdmin = userInfo.isAdmin === '1' || false;
    store.commit('erpConfig', data);
    store.commit('warehouseId', data.warehouseId);
    store.commit('currency', data.currency);
    store.commit('isAdmin', isAdmin);
    commonSessionStorage.setItem('erpConfig', data);
    commonSessionStorage.setItem('isAdmin', isAdmin);
    localStorage.setItem('warehouseId', JSON.stringify(data.warehouseId));
    ensureImInit({
      merchantId: merchant.merchantId,
      memberId: userInfo.userId,
      memberName: userInfo.userName,
      role: userInfo.roleName,
      loginUrl: null
    });
    webDataCollectionFn();
    await getShoppingConfig(userInfo, type);
    return true;
  };
  
  return new Promise(async (resolve) => {
    try {
      let cacheData = commonSessionStorage.getItem('erpConfig') || store.state.erpConfig;
      let data = cacheData && Object.keys(cacheData).length > 0 && !forceFlush ? cacheData : null;
      if (!data) {
        const response = await axios.get(api.get_erpConfig + '?time=' + new Date().getTime());
        if (response.data.code !== 0 || !response.data.datas) {
          resolve(false);
          return;
        }
        data = response.data.datas;
      }
      const configured = await configureBasicInformation(data);
      resolve(configured ? data : false);
    } catch (e) {
      console.error('getErpconfig error:', e);
      resolve(false);
    }
  });
};

// 云卖初始化IM配置
export const imInit = ({memberId, memberName, merchantId, role, loginUrl} = {}) => {
  let systemType = getSystemType();
  let pageConfig = commonLocalStorage.getItem('pageConfig') || store.state.pageConfig;
  let systemEnvironment = pageConfig?.systemEnvironment;
  // 非阿里国际分销商和商城、泰瑞森的供应商 才需要初始化IM入口
  let value = (['distributor', 'shopping'].includes(systemType) && !isAlibabaDistributor()) ||
    (systemType === 'supplier' && systemEnvironment === 'trs');
  // erp2.0：1，刊登：2，官网：3，YMS：4，供应商：8
  let projectCode = systemType === 'supplier' ? '8' : '4';
  if (value) {
    if (!window.tmsIm) {
      console.warn(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002116'));
      return;
    }
    let obj = {};
    if (systemEnvironment === 'trs') {
      obj.sassMerchantId = systemEnvironment;
    }
    let env = getEnvFromOrigin();
    new window.tmsIm({
      // 用户id
      memberId: memberId || '',
      // 用户名
      memberName: memberName || '',
      // 商户编号
      merchantId: merchantId || '',
      // 【必填】项目
      projectCode: projectCode,
      // 用户角色
      role: role || '',
      // 引导登录地址
      loginUrl: loginUrl || '',
      // 【必填】连接im环境 可选值 dev test pro  对应开发环境、测试环境、生产环境
      env: env,
      // 【必填】im serviceUrl 地址
      serviceUrl: getServiceUrl(env, systemEnvironment),
      ...obj
    });
  } else {
    if(systemType !== 'yms') {
      console.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002117'));
    }
  }
};

/**
 * 获取分销商 ERP 配置，并同步商城端依赖的基础数据。
 * @param {boolean} isLogin 是否按登录态请求配置。
 * @returns {Promise<Object|string|boolean>} 成功返回配置对象，未登录返回 noLogin，请求失败返回 false。
 */
export const getDistributorErpConfig = (isLogin) => {
  return new Promise(async (resolve) => {
    let params = {};
    if (!isLogin) {
      params = {
        headers: {'Authorization-Special': 'no-Login'}
      };
    }
    try {
      const response = await axios.get(api.get_distributorErpConfig + '?time=' + new Date().getTime(), params);
      if (response && response.data && response.data.code === 0) {
        let data = response.data.datas;
        let {merchant, userInfo} = data || {};
        if (!merchant || !userInfo) {
          resolve(false);
          return;
        }
        let isAdmin = userInfo.isAdmin === '1' || false;
        store.commit('erpConfig', data);
        store.commit('currency', data.currency);
        store.commit('isAdmin', isAdmin);
        commonSessionStorage.setItem('isAdmin', isAdmin);
        commonSessionStorage.setItem('erpConfig', data);
        webDataCollectionFn();
        ensureImInit({
          merchantId: merchant.merchantId,
          memberId: userInfo.userId,
          memberName: userInfo.userName,
          role: userInfo.roleName,
          loginUrl: null
        });
        await getShoppingConfig(userInfo, 'shopping');
        resolve(response.data.datas);
        return;
      }
      let href = window.location.href;
      ensureImInit({
        loginUrl: window.location.origin + `/yms-shopping-service/login.html#/login?u=${href}`
      });
      await getShoppingConfig('', 'shopping');
      resolve('noLogin');
    } catch (e) {
      console.error('getDistributorErpConfig error:', e);
      resolve(false);
    }
  });
};

/** 检查当前应用版本是否已变更 */
export const checkAppVersion = async () => {
  try {
    const {data} = await axios.get('./static/version.js', {
      headers: {'Cache-Control': 'no-cache'}
    });
    if (data?.code === 0) {
      const newVersion = data.datas.version + '';
      const oldVersion = localStorage.getItem(versionName);
      if (newVersion !== oldVersion) {
        localStorage.setItem(versionName, newVersion);
        if (oldVersion) {
          return true;
        }
      }
    }
  } catch (e) {
    console.error('Version check failed:', e);
  }
  return false;
};

/**
 * @Description: 判断访问的页面是否存在，不存在即重定向到404页面
 * @author jing
 * @date 2021/6/17 13:37
 * @params:
 */
export const nonexistent = (to, next) => {
  const isNotFound = to.matched.length === 0;
  if (isNotFound) {
    return next({
      path: '/noPersermission',
      query: {
        type: '404'
      }
    });
  }
  next();
};

// 获取当前页面下的操作按钮的权限
/**
 * 获取单页按钮级权限。
 * @param {string} menuKey 页面菜单 key。
 * @param {string} service 指定子系统 service，可为空。
 * @returns {Promise<Object|boolean>} 成功返回权限 map，无权限或失败返回 false。
 */
export const getSinglePageRoleCommon = (menuKey, service) => {
  let subsystemCode = service ? service : targetService;
  return new Promise((resolve) => {
    // supplier_productCenter_productGoods 外部创建页面
    if (['supplier_productDetailsByExternal'].includes(menuKey) || menuKey.indexOf('noPersermission') > 0) {
      resolve(true);
    } else {
      let url = service ? api.post_ymsDistributorUserInfo_queryOperByMenu : '';
      switch (system) {
        case 'yms':
          url = api.post_ymsCoreUserInfo_queryOperByMenu;
          break;
        case 'supplier':
          url = api.post_ymsSupplierUserInfo_queryOperByMenu;
          break;
        case 'distributor':
          url = api.post_ymsDistributorUserInfo_queryOperByMenu;
          break;
      }
      axios.post(url + menuKey + `?subsystemCode=${subsystemCode}`).then(response => {
        if (response.data.code === 0) {
          let pos = {};
          let data = response.data.datas || [];
          const existingPermissions = commonLocalStorage.getItem('pagePermissionsList') || {};
          if (data.length > 0) {
            data.map((item) => {
              pos[item] = true;
            });
            existingPermissions[menuKey] = data;
            commonLocalStorage.setItem('pagePermissionsList', existingPermissions);
          }
          if (Object.keys(pos).length > 0) {
            commonLocalStorage.setItem('roleList', pos);
            store.commit('roleList', pos);
          }
          resolve(pos);
          return;
        }
        resolve(false);
      }).catch((e) => {
        console.error('getSinglePageRoleCommon error:', e);
        resolve(false);
      });
    }
  });
};

/**
 * 获取当前页面帮助中心文档。
 * @param {string} menuKey 页面菜单 key。
 * @param {string} service 当前平台标识。
 * @returns {Promise<Array>} 帮助文档列表。
 */
export const getSinglePageHelp = async (menuKey, service) => {
  try {
    let _url = null;
    if (service === 'ymsCore') {
      _url = api.post_helpCenterDocs_queryByModule;
    } else if (service === 'ymsSupplier') {
      _url = api.post_helpCenterDocs_queryByModule_supplier;
    } else if (service === 'ymsDistributor') {
      _url = api.post_helpCenterDocs_queryByModule_distributor;
    }
    const {data} = await axios.post(_url, {
      moduleId: menuKey,
      platformId: service,
    });
    const {code, datas} = data;
    if (code === 0) {
      store.commit('helpGuide', datas);
      return datas;
    }
  } catch (e) {
    console.error('getSinglePageHelp error:', e);
  }
  return [];
}

// 获取用户菜单权限
/**
 * 获取当前用户菜单权限。
 * @param {string} service 指定子系统 service，可为空。
 * @returns {Promise<Array|boolean|null>} 成功返回权限数组，拦截器已处理返回 null，失败返回 false。
 */
export const getQueryMenu = (service) => {
  let subsystemCode = service ? service : targetService;
  return new Promise((resolve) => {
    let roleData = commonLocalStorage.getItem('roleData') || store.state.roleData || [];
    if (roleData.length > 0) {
      commonLocalStorage.setItem('roleData', roleData)
      store.commit('roleData', roleData);
      resolve(roleData);
    } else {
      let url = service ? api.get_ymsDistributorUserInfo_queryMenu : '';
      switch (system) {
        case 'yms':
          url = api.get_ymsCoreUserInfo_queryMenu;
          break;
        case 'supplier':
          url = api.get_ymsSupplierUserInfo_queryMenu;
          break;
        case 'distributor':
          url = api.get_ymsDistributorUserInfo_queryMenu;
          break;
      }
      axios.get(url + `?subsystemCode=${subsystemCode}`).then(response => {
        if (response.data.code === 0) {
          let newRoleData = response.data.datas || [];
          commonLocalStorage.setItem('roleData', newRoleData)
          store.commit('roleData', newRoleData);
          resolve(newRoleData);
          return;
        }
        // 拦截器已处理的权限/停用类错误，不再向上抛初始化失败
        if (isInterceptorHandled) {
          resolve(null);
          return;
        }
        resolve(false);
      }).catch((e) => {
        console.error('getQueryMenu error:', e);
        resolve(false);
      });
    }
  });
};

// 登录也检查登录
export const checkLogin = () => {
  return new Promise(resolve => {
    axios.post(api.post_ymsUserInfo_checkLogin, {
      u: getQueryString('u')
    }).then((response) => {
      if (response.data.datas) {
        window.location.href = response.data.datas;
      }
      resolve();
    }).catch(() => {
      resolve();
    });
  });
};

/**
 * 获取商户校验信息 缺少信息会跳转绑定信息页面
 * @date: 2022/3/28 15:19
 */
export const getValidMerchant = async (type) => {
  let pageConfig = commonLocalStorage.getItem('pageConfig');
  const value = pageConfig?.systemEnvironment;
  if (value !== 'yms') return true;
  try {
    if (type === 'shopping' || await verifyLoginTicket()) {
      await axios.get(api.get_ymsDistributorCommon_validMerchant);
      // shopping 场景下，1113022/1113023/999990 等错误码由 http 拦截器统一处理弹窗，
      // 路由守卫不再阻断导航，避免页面空白
    }
  } catch (e) {
  }
  return true;
};

// 查询当前商城、分销商的商品活动、广告设置、商品设置
/**
 * 获取商城首页运行依赖的活动和广告配置。
 * @param {Object|string} userInfo 当前用户信息。
 * @param {string} type 当前系统类型。
 * @returns {Promise<boolean>} 始终返回 true，确保不阻塞页面初始化。
 */
export const getShoppingConfig = (userInfo, type) => {
  return new Promise(async (resolve) => {
    if (['distributor', 'shopping'].includes(type)) {
      try {
        await Promise.all([getOngoingActivities(type), getMallAdvertising(type)]);
      } catch (e) {
        console.error('getShoppingConfig error:', e);
      }
    }
    resolve(true);
  });
}

// 获取店铺域名中的语种参数
export const getStoreDomainName = () => {
  let origin = window.location.origin;
  const currentURL = window.location.href;
  let lang = '';
  if (origin.includes('shop') && origin.includes('.yms.com')) {
    const urlObj = new URL(currentURL);
    lang = urlObj.searchParams.get('lang');
  }
  return lang;
}

// 获取当前系统语言（商户配置 > 本地缓存 > 系统默认 > 浏览器）
export const getSystemLanguage = (userInfo) => {
  return new Promise((resolve) => {
    const configureLanguage = commonLocalStorage.getItem('configureLanguage') || store.state.configureLanguage || [];
    const findLang = code => configureLanguage.find(i => i.name === code);
    const resolveLang = (langCode, type) => {
      const langItem = findLang(langCode);
      localStorage.setItem('lang', langCode);
      store.commit('setLanguages', langCode);
      localStorage.setItem('setLanguages', langCode);
      if (langItem) {
        commonSessionStorage.setItem('flagPath', langItem.iconPath);
        commonSessionStorage.setItem('selectLang', langItem.title);
        Vue.config.lang = langItem.name;
      }
      if (type === 'update') {
        Modal.warning({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
          transfer: true,
          zIndex: 1000,
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002118'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002119'),
          onOk: () => {
            changeUserLanguages(langCode).then((val) => {
              if (val) {
                setTimeout(() => {
                  window.location.reload();
                }, 300);
              }
            })
          }
        });
      }
      resolve({langCode, configureLanguage});
    };
    
    const fallback = () => {
      const cacheLang = localStorage.getItem('lang');
      // 本地缓存语种
      if (cacheLang) return resolveLang(cacheLang);
      // 系统默认语种
      const defaultLang = configureLanguage.find(i => i.defaultLanguage)?.name;
      if (defaultLang) return resolveLang(defaultLang);
      // 浏览器默认语种
      const browserLang = ['zh', 'zh-CN'].includes(navigator.language)
        ? 'zh-CN' : ['en', 'en-US'].includes(navigator.language)
          ? 'en-US' : 'zh-CN';
      resolveLang(browserLang);
    };
    // 商户语种
    if (userInfo?.userId) {
      let code = null;
      getCommonParamKeysData(userInfo.userId, ['language'], false, true).then(res => {
        const langCode = res?.find(i => i.paramKey === 'language')?.paramValue;
        if (langCode) {
          configureLanguage.map((item) => {
            if (item.name === langCode) {
              code = item.name;
            }
          });
          if (code) {
            resolveLang(code)
          }
          // 如果当前用户设置了语种，语种没有在当前配置的语种可选值中，则使用设置的系统默认语种
          else {
            const defaultLang = configureLanguage.find(i => i.defaultLanguage)?.name;
            resolveLang(defaultLang, 'update')
          }
        } else {
          fallback();
        }
      }).catch(fallback);
    } else {
      fallback();
    }
  });
};
